import React, {Component} from "react";
import OverlayAuth from "./Auth/OverlayAuth";
import Footer from "../components/Footer";
import Main from "./Main";
import {AdobeAnalyticsContext} from "../context/AdobeAnalyticsContext";
import {UserContext} from "../context/UserContext";
import {LandingPage} from "../components/LandingPage";

interface Props {
    locale: string;
}

export default class WebApp extends Component<Props> {
    static contextType = UserContext;
    context!: React.ContextType<typeof UserContext>;

    render(): JSX.Element {
        return (
            <>
                <main role="main" className="webapp">
                    <AdobeAnalyticsContext.Consumer>
                        {analytics => (
                            <OverlayAuth
                                applicationId={process.env.REACT_APP_APP_ID}
                                genomeId={process.env.REACT_APP_GENOME_ID}
                                environment={process.env.REACT_APP_UBISOFT_CONNECT_ENV || 'prod'}
                                locale={this.props.locale}
                                analytics={analytics}
                            >

                                {this.context.user.isAuthenticated && <Main locale={this.props.locale} analytics={analytics}/>}
                                {!this.context.user.isAuthenticated && <LandingPage locale={this.props.locale}/>}

                                <Footer analytics={analytics}/>
                            </OverlayAuth>
                        )}
                    </AdobeAnalyticsContext.Consumer>
                </main>
            </>
        );
    }
}